// @flow

export const osagoTransportType = {
  tractor: 'Трактор',
  wheel: 'Колесный транспорт'
};
